import { ThemeOptions } from '@mui/material/styles';
import { darkColors, brand, iconBadgeTones, buildShadows } from './tokens';
import { buildComponents } from './componentOverrides';
import { ITorqTheme } from './torqTypes';
import { menuPetroleo } from './Light';

const torq: ITorqTheme = {
  surface: {
    page: darkColors.page,
    level2: darkColors.level2,
    card: darkColors.card,
    elevated: darkColors.elevated,
  },
  border: {
    default: darkColors.borderDefault,
    strong: darkColors.borderStrong,
    focus: darkColors.borderFocus,
  },
  text: {
    primary: darkColors.textPrimary,
    secondary: darkColors.textSecondary,
    muted: darkColors.textMuted,
    disabled: darkColors.textDisabled,
  },
  hover: darkColors.hover,
  selected: darkColors.selected,
  scrollbarThumb: darkColors.scrollbarThumb,
  scrollbarThumbHover: darkColors.scrollbarThumbHover,
  dialogShadow: darkColors.dialogShadow,
  iconBadge: iconBadgeTones,
  accentText: brand.primary,
  cardShadow: darkColors.cardShadow,
  // Mesmo menu petróleo do tema claro.
  sidebar: { ...menuPetroleo, divider: menuPetroleo.border, scrollbarThumb: darkColors.scrollbarThumb },
};

export const darkThemeOptions: ThemeOptions = {
  palette: {
    mode: 'dark',
    // `dark` de cada cor = versão legível como texto sobre fundo escuro.
    primary: { main: brand.primary, dark: brand.primary, light: brand.primaryLight, contrastText: brand.menuBase },
    secondary: { main: brand.info, dark: '#7DB2FF', light: '#A9CCFF', contrastText: '#FFFFFF' },
    error: { main: brand.error, dark: '#FF8A92', light: '#FFB3B8', contrastText: '#FFFFFF' },
    warning: { main: brand.warning, dark: '#FFCF57', light: '#FFE08F', contrastText: brand.menuBase },
    success: { main: brand.success, dark: '#7BDD66', light: '#A5E998', contrastText: brand.menuBase },
    info: { main: brand.info, dark: '#7DB2FF', light: '#A9CCFF', contrastText: '#FFFFFF' },

    background: {
      paper: darkColors.card,
      default: darkColors.page,
    },

    text: {
      primary: darkColors.textPrimary,
      secondary: darkColors.textSecondary,
      disabled: darkColors.textDisabled,
    },

    divider: darkColors.borderDefault,
  },

  typography: {
    fontFamily: '"Plus Jakarta Sans", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',

    h1: { fontWeight: 700, color: darkColors.textPrimary, fontSize: '2.5rem', letterSpacing: '-0.02em' },
    h2: { fontWeight: 700, color: darkColors.textPrimary, fontSize: '2rem', letterSpacing: '-0.02em' },
    h3: { fontWeight: 700, color: darkColors.textPrimary, fontSize: '1.875rem', letterSpacing: '-0.015em' },
    h4: { fontWeight: 700, color: darkColors.textPrimary, fontSize: '1.5rem', letterSpacing: '-0.01em' },
    h5: { fontWeight: 650, color: darkColors.textPrimary, fontSize: '1.375rem' },
    h6: { fontWeight: 600, color: darkColors.textPrimary, fontSize: '1rem' },

    subtitle1: { color: darkColors.textSecondary },
    subtitle2: { color: darkColors.textMuted },

    body1: { color: darkColors.textPrimary, lineHeight: 1.6, fontSize: '0.875rem' },
    body2: { color: darkColors.textSecondary, lineHeight: 1.5, fontSize: '0.8125rem' },

    caption: { color: darkColors.textMuted, fontSize: '0.75rem' },
    overline: { color: darkColors.textMuted },

    button: { textTransform: 'none', fontWeight: 600, fontSize: '0.8125rem' },
  },

  // 6: `borderRadius: 2` no sx das telas multiplica este valor (= 12px).
  shape: { borderRadius: 6 },

  torq,

  components: buildComponents('dark', torq),

  shadows: buildShadows('dark'),
};
